import AppConfig from './app-config';
import CommonConfig from './common-config';
import Config from './config';
export default {
  AppConfig,
  CommonConfig,
  Config
};